import React, { useMemo } from 'react'
import { constants, VillageType } from 'helpers'
import { Alert, DownloadableCard } from 'components'
import { MenuSvgs } from 'assets'
import { colors } from 'styles/colors'
import { DownloadStatus } from 'types'
import { useDownloadVillage } from 'hooks'
import { hasLocalDataExpired } from 'datastores/LocalDataExpiration'

export type DownloadVillageCardProps = {
    village: VillageType
    openClickHandler: (village: VillageType) => void
    downloadErrorMsg?: string
}

export const DownloadVillageCard = ({
    village,
    openClickHandler,
    downloadErrorMsg
}: DownloadVillageCardProps) => {
    const villageIds = useMemo(() => [village.sf_id], [village.sf_id])

    const subtitles = useMemo(
        () =>
            (village.ves?.map((ve) => ve.name || '') || []).concat([
                village.code || ''
            ]),
        [village.ves, village.code]
    )

    const { downloadStatus, fetchVillageData, isDownloadError } =
        useDownloadVillage(villageIds)

    const { VillagesIcon } = MenuSvgs

    const clickHandler = () => {
        const isDataExpired = hasLocalDataExpired(
            constants.CLIENT_LIST_EXPIRATION_NAME,
            village.sf_id
        )

        if (
            downloadStatus === DownloadStatus.NOT_DOWNLOADED ||
            (downloadStatus === DownloadStatus.DOWNLOADED && isDataExpired)
        ) {
            fetchVillageData()
        }

        if (downloadStatus === DownloadStatus.DOWNLOADED) {
            openClickHandler(village)
        }
    }

    return (
        <>
            <DownloadableCard
                key={village.code}
                headerColor={colors.lighterGreen}
                borderBottomColor={colors.primary}
                icon={
                    <VillagesIcon
                        width="35"
                        height="35"
                        color={colors.primary}
                    />
                }
                title={village.name || ''}
                subtitles={subtitles}
                status={downloadStatus}
                clickHandler={clickHandler}
            />

            {isDownloadError && (
                <Alert type="floating" status={'error'}>
                    {downloadErrorMsg}
                </Alert>
            )}
        </>
    )
}
